import React from 'react';

class Redirect extends React.Component {

    componentDidMount() {
        window.location.replace("/blog/product-updates/covid19-remote-map/");
    }

    render() {
        return (
            ""
        );
    }
}

export default Redirect;
